export class HEventType {
    static get INDIVIDUAL() { return 0; }
    static get RELAYS() { return 1; }
}

export default class HEvent {
    ID = -1;
    Name = "";
    Type = HEventType.INDIVIDUAL;
    static FromDB(r) {
        var o = new HEvent();
        o.ID = r.ID;
        o.Name = r.Name;
        o.Type = r.Type;
        return o;
    }
}
export class HEventSettings {
    starttime = null;
}